/*
 * @FilePath     : /es-package/packages/es-mpx-template/src/common/sig.js
 * @Author       : LiYang
 * @Date         : 2021-08-24 17:40:31
 * @LastEditTime : 2021-12-30 16:52:28
 * @LastEditors  : Please set LastEditors
 * @Description  : 请求加密处理
 */

import md5 from 'md5'
import wsgsig from '@didi/wsgsig'
import { compose } from '@didi/es-mpx-shared'

export const serialize = (params) => Object.keys(params).sort().map(key => {
  const val = params[key]
  if (typeof val === 'undefined' || val === null) {
    return
  }
  return decodeURIComponent(key) + '=' + decodeURIComponent(encodeURIComponent(val))
}).filter(key => !!key).join('&')

export const sig = (str) => str && md5(str.substring(0, str.length))

export const getSign = (target) => wsgsig({ params: target, noDomainCheck: true })

// 企业级签名
export const esMd5 = (params) => Object.assign(params, {
  sig: sig(serialize(params))
})

// 安全部签名
export const wgMD5 = (params) => Object.assign(params, {
  wsgsig: getSign(params)
})

export const tranver = compose(wgMD5, esMd5)

export const now = () => +Date.now()
